module.exports = __webpack_public_path__ + "img/arrow-back.f535feb6.svg";